import { modulesAdapters } from './module_adapters'

export const baichuanAdapter = data => {
  data.style.pt = 2
  data.style.pb = 2
  data.style.mt = -2
  data.modules.forEach(module => {
    if (modulesAdapters[module.moduleName]) {
      module = modulesAdapters[module.moduleName](module)
    }
  })
  return data
}
